import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import DOMPurify from 'dompurify';
import { useEffect, useState } from 'react';
import { getHighlighter } from 'shiki/bundle/web';
import { themeConfig } from "../theme";

// 目前支持的语言列表
export var HIGHLIGHT_LANGUAGES = ['javascript', 'typescript', 'css', 'json', 'markdown', 'xml', 'html', 'yaml', 'tsx', 'jsx', 'java', 'python', 'sql', 'bash', 'sh', 'vue', 'vue-html'];
export var useShiki = function useShiki(language, theme) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    shiki = _useState2[0],
    setShiki = _useState2[1];
  var initShiki = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var highlighter;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getHighlighter({
              langs: HIGHLIGHT_LANGUAGES,
              themes: [themeConfig(true), themeConfig(false)]
            });
          case 2:
            highlighter = _context.sent;
            setShiki(highlighter);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function initShiki() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    initShiki();
  }, []);
  var renderShiki = function renderShiki(content) {
    if (shiki && shiki.getLoadedLanguages().includes(language)) {
      var result = shiki === null || shiki === void 0 ? void 0 : shiki.codeToHtml(content, {
        lang: language,
        theme: theme
      });
      return DOMPurify.sanitize(result);
    } else {
      // 在shiki加载完成之前，直接返回原始代码，同样需要进行xss过滤
      return DOMPurify.sanitize("<pre><code>".concat(content, "</code></pre>"));
    }
  };
  return {
    loading: !shiki,
    renderShiki: renderShiki
  };
};